import { lightThemeColors } from '@/styles/vuetify';
import { StateOfUse } from './types';

const color = {
  grey: lightThemeColors['state-of-use-other'],
  red: lightThemeColors['error-lighten-3'],
  blue: lightThemeColors['info'],
  green: lightThemeColors['state-of-use-enabled'],
};

export function getColor(state: StateOfUse) {
  switch (state) {
    case 'Enabled':
      return color.green;
    case 'InEditing':
      return color.blue;
    default:
      return color.grey;
  }
}
